import { SupportedAgeGroupItem } from '@uplift/types';
import { restClient } from '../../client';

export type SupportedAgesResponse = {
  ages: SupportedAgeGroupItem[];
};

export const getSupportedAgeGroups = () =>
  restClient.request<SupportedAgesResponse>('/api/v1/matching/supported_ages');
